function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query getRegions(\n    $where: Regions_bool_exp\n    $orderBy: [Regions_order_by!]\n    $offset: Int\n    $limit: Int\n  ) {\n    Regions(order_by: $orderBy, offset: $offset, limit: $limit, where: $where) {\n      alias\n      deployment_api_url\n      assets_api_url\n      marketplace_api_url\n      enabled\n      default\n      host_template\n      name\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
import { useQuery } from "./useGraphQLApi";
var GET_REGIONS_QUERY = gql(_templateObject());
export var useRegionsQuery = function(params, options) {
    var _useQuery = useQuery(GET_REGIONS_QUERY, params, options), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    var _data_Regions;
    return {
        data: (_data_Regions = data === null || data === void 0 ? void 0 : data.Regions) !== null && _data_Regions !== void 0 ? _data_Regions : [],
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};

//# sourceMappingURL=useRegions.js.map